import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux"; // Assuming you're using Redux

const PrivateRoute = () => {
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const location = useLocation();
  
  // Allow access to session-expired page even when not authenticated
  const isSessionExpiredPage = location.pathname === '/session-expired';
  
  // If the user is logged in, allow access to child routes
  // Or if it's the session-expired page, allow access regardless of auth status
  return isLoggedIn || isSessionExpiredPage ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
